//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'
import { mdiInstagram, mdiTwitter, mdiWhatsapp } from '@mdi/js'

export default {
  setup() {
    const showInstagramBadgeOnHover = ref(false)
    const showTwitterBadgeOnHover = ref(false)
    const showWhatsappBadgeOnHover = ref(false)

    return {
      showInstagramBadgeOnHover,
      showTwitterBadgeOnHover,
      showWhatsappBadgeOnHover,

      // icons
      icons: { mdiInstagram, mdiTwitter, mdiWhatsapp },
    }
  },
}
